import React, { useEffect, useState } from 'react';
import './newproject.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { addDoc, collection, doc, getDoc, getDocs, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes, uploadBytesResumable } from 'firebase/storage';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { BsCheck2Circle } from 'react-icons/bs';
import { auth, db, storage } from '../../../firebase';
import Modal from '../../../components/Modal/Modal';
import { FaAnglesLeft } from 'react-icons/fa6';
import { BiXCircle } from 'react-icons/bi';
import { LuImagePlus } from 'react-icons/lu';

const quillModules = {
    toolbar: [
        [{ 'font': [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' },
        { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image', 'video'],
        ['clean']
    ]
};

const quillFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video'
];

function EditProject() {

    const { id } = useParams();

    const [projectName, setProjectName] = useState('');
    const [year, setYear] = useState('');
    const [projectType, setProjectType] = useState('');
    const [content, setContent] = useState('');
    const [cover, setCover] = useState('');
    const [client, setClient] = useState('');

    const [missions, setMissions] = useState([]);
    const [projectWebsite, setProjectWebsite] = useState('');
    const [projectInstagram, setProjectInstagram] = useState('');

    const [newMission, setNewMission] = useState("");

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                const articleRef = doc(db, 'projects', id);
                const snapshot = await getDoc(articleRef);
                const projectData = snapshot.data();

                if (projectData) {
                    setProjectType(projectData.projectType);
                    setProjectName(projectData.projectName);
                    setYear(projectData.year);
                    setCover({
                        file: null,
                        preview: projectData.coverUrl,
                    });
                    setClient(projectData.client);
                    setContent(projectData.content);
                    setMissions(projectData.missions);
                    setProjectWebsite(projectData.projectWebsite);
                    setProjectInstagram(projectData.projectInstagram);

                    // 👇 Correction ici
                    if (projectData.images && projectData.images.length > 0) {
                        setImages(projectData.images.map(url => ({
                            file: null,
                            preview: url
                        })));
                    }
                }
            } catch (error) {
                console.error("Error fetching article: ", error);
            }
        };

        fetchArticle();
    }, [id]);

    const addMission = () => {
        if (newMission.trim() !== "") {
            setMissions([...missions, newMission]);
            setNewMission(""); // Réinitialiser l'input
        }
    };

    const removeMission = (index) => {
        setMissions(missions.filter((_, i) => i !== index));
    };


    const [images, setImages] = useState([]);
    const [imageUrls, setImageUrls] = useState([]);

    const handleImages = (event) => {
        const files = Array.from(event.target.files);
        const newImages = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));
        setImages((prev) => [...prev, ...newImages]);
    };

    const removeImage = (index) => {
        setImages(images.filter((_, i) => i !== index));
    };

    const uploadImages = async () => {
        const urls = [];

        for (const image of images) {

            // Si c'est une ancienne image (déjà en ligne)
            if (!image.file && image.preview) {
                urls.push(image.preview);
                continue;
            }

            // Si nouvelle image uploadée
            if (image.file) {
                const storageRef = ref(storage, `projects/${Date.now()}-${image.file.name}`);
                const uploadTask = uploadBytesResumable(storageRef, image.file);

                await new Promise((resolve, reject) => {
                    uploadTask.on(
                        "state_changed",
                        null,
                        (error) => reject(error),
                        async () => {
                            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                            urls.push(downloadURL);
                            resolve();
                        }
                    );
                });
            }
        }

        return urls;
    };

    const user = auth.currentUser;
    //Récupérer les données de l'utilisateur
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            const q = query(collection(db, "users"),
                where("email", "==", user.email))
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                setUserData(doc.data());
            })
        };
        fetchUserData();
    }, [user]);

    const handleCover = (event) => {
        const file = event.target.files[0];
        if (file) {
            setCover({
                file,
                preview: URL.createObjectURL(file)
            });
        }
    };

    const removeCover = () => {
        setCover(null);
    };

    const handleChange = (newValue) => {
        setContent(newValue);
    };

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        navigate(-1);
    }

    const [isLoading, setIsLoading] = useState(false);

    const updateProject = async (event) => {
        try {
            event.preventDefault();
            setIsLoading(true); // Afficher le loader

            const uploadedImageUrls = await uploadImages(); // Upload des images avant d'ajouter l'événement

            // Adding the article to Firebase Firestore
            await updateDoc(doc(db, "projects", id), {
                projectName: projectName,
                year: year,
                projectType: projectType,
                content: content,
                client: client,
                missions: missions,
                projectWebsite: projectWebsite,
                projectInstagram: projectInstagram,
                images: uploadedImageUrls,

                lastModif: new Date(),
            });

            setIsLoading(false);

            setOpen(true)

        } catch (error) {
            setIsLoading(false);
            console.error("Error adding article: ", error);
        }
    };

    const updateCover = async (event) => {
        event.preventDefault();
        setIsLoading(true); // Afficher le loader

        // Télécharger la photo de profil sur Firebase Storage
        const fileRef = ref(storage, `article_covers/${cover.file.name}`);
        await uploadBytes(fileRef, cover.file);

        // Récupérer l'URL de téléchargement de la photo de profil
        const coverUrl = await getDownloadURL(fileRef);

        const articleDocRef = doc(db, 'projects', id)
        try {
            await updateDoc(articleDocRef, {
                coverUrl: coverUrl,
                lastModif: Timestamp.now()
            })
            setOpen(true)
            setIsLoading(false);
        }
        catch (error) {
            console.error("Error updating article: ", error);
            setIsLoading(false);
        }
    };


    const navigate = useNavigate();

    return (
        <div id='newArticle' className='px-[60px]'>

            <section className="flex pb-[30px]" id='blog'>

                <div className="xl:flex hidden justify-start items-center">
                    <Link onClick={() => navigate(-1)} className="font-pressura flex items-center text-tangerine text-[14px]">
                        <FaAnglesLeft className='text-[10px]' />
                        Back
                    </Link>
                </div>

            </section>

            <div className='flex flex-col justify-center w-full'>

                <form className='ppmori items-center w-2/3' onSubmit={updateCover}>

                    <div className="my-10">

                        <label className='text-white'>Photo de couverture</label>

                        <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-purple-500 transition-all">
                            <input
                                type="file"
                                onChange={handleCover}
                                accept="image/*"
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                            />
                            <p className="text-gray-500">Cliquez ou glissez une image ici</p>
                        </div>

                        {/* Preview de la cover */}
                        {cover && (
                            <div className="relative mt-4 w-full max-w-md mx-auto">
                                <img
                                    src={cover.preview}
                                    alt="Cover preview"
                                    className="w-full rounded-lg shadow-lg object-cover max-h-[350px]"
                                />
                                <button
                                    onClick={removeCover}
                                    className="absolute top-2 right-2 bg-red-500 text-white p-1.5 rounded-full shadow-lg hover:bg-red-600 transition"
                                >
                                    <BiXCircle size={20} />
                                </button>
                            </div>
                        )}
                    </div>

                    <div className='btn-ctrl'>
                        <button className="buttonviolet w-[200px!important]">
                            {isLoading ? (
                                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <p>Mettre à jour la cover</p>
                            )}
                        </button>
                    </div>

                </form>


                <form className='ppmori items-center w-2/3' onSubmit={updateProject}>

                    <div className='form-ctrl'>
                        <label className='text-white'><p className=''>Type de projet</p></label>
                        <select
                            value={projectType}
                            onChange={(e) => setProjectType(e.target.value)}
                            required>
                            <option >-Sélectionner le type de votre projet-</option>
                            <option value="Brand">Brand</option>
                            <option value="Creation">Creation</option>
                            <option value="Event & Experience">Event & Experience</option>

                        </select>
                    </div>

                    <div className='form-ctrl'>
                        <label className='text-white'><p>Nom du projet</p></label>
                        <input type="text"
                            className='outline-none border-2 px-4 py-2 rounded-md w-full'
                            value={projectName}
                            onChange={(event) => setProjectName(event.target.value)}
                            required
                        />
                    </div>

                    <div className='form-ctrl'>
                        <label className='text-white'><p>Année</p></label>
                        <select
                            className='outline-none border-2 px-4 py-2 rounded-md w-full'
                            value={year}
                            onChange={(event) => setYear(event.target.value)}
                            required
                        >
                            <option value="">Sélectionner une année</option>
                            {Array.from({ length: 100 }, (_, i) => {
                                const year = new Date().getFullYear() - i;
                                return <option key={year} value={year}>{year}</option>;
                            })}
                        </select>

                    </div>

                    <div className='form-ctrl'>
                        <label className='text-white'><p>Instagram</p></label>
                        <input type="text"
                            className='outline-none border-2 px-4 py-2 rounded-md w-full'
                            value={projectInstagram}
                            onChange={(event) => setProjectInstagram(event.target.value)}
                            required
                        />
                    </div>

                    <div className='form-ctrl'>
                        <label className='text-white'><p>Site web</p></label>
                        <input type="text"
                            className='outline-none border-2 px-4 py-2 rounded-md w-full'
                            value={projectWebsite}
                            onChange={(event) => setProjectWebsite(event.target.value)}
                        />
                    </div>

                    <div className='form-ctrl'>
                        <label className='text-white'><p>Client</p></label>
                        <input type="text"
                            className='outline-none border-2 px-4 py-2 rounded-md w-full'
                            value={client}
                            onChange={(event) => setClient(event.target.value)}
                        />
                    </div>

                    <div className="my-10">
                        <div className='form-ctrl'>
                            <label className='text-white'><p className=''>Missions du projet</p></label>
                            <div className="flex gap-2">
                                <input
                                    type="text"
                                    className='outline-none border-2 px-4 py-2 rounded-md w-full'
                                    value={newMission}
                                    onChange={(e) => setNewMission(e.target.value)}
                                    placeholder="Ajouter une mission"
                                />
                                <button
                                    type="button"
                                    className="bg-green-500 text-white px-4 py-2 rounded-md"
                                    onClick={addMission}
                                >
                                    Ajouter
                                </button>
                            </div>
                        </div>

                        {/* Affichage des missions */}
                        {missions.length > 0 && (
                            <ul className="mt-4 space-y-2 w-1/2">
                                {missions.map((mission, index) => (
                                    <li key={index} className="flex justify-between items-center bg-gray-100 px-4 py-2 rounded-md">
                                        <span>{mission}</span>
                                        <button
                                            type="button"
                                            className="bg-red-500 text-white px-2 py-1 rounded-md text-xs"
                                            onClick={() => removeMission(index)}
                                        >
                                            X
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <div className='form-ctrl text-white'>
                        <label className='text-white'>Description du projet</label>
                        <ReactQuill
                            value={content}
                            onChange={handleChange}
                            modules={quillModules}
                            formats={quillFormats}
                        />
                    </div>

                    <div className="mt-20">
                        {/* Zone de drop pour les images */}
                        <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-purple-500 transition-all">
                            <input
                                type="file"
                                multiple
                                onChange={handleImages}
                                accept="image/*"
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                            />
                            <div className="flex flex-col items-center text-gray-500">
                                <LuImagePlus size={40} className="mb-2" />
                                <p className="text-sm">Cliquez ou glissez des images ici</p>
                            </div>
                        </div>

                        {/* Affichage des images sélectionnées */}
                        {images.length > 0 && (
                            <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-6">
                                {images.map((img, index) => (
                                    <div key={index} className="relative group">
                                        <img
                                            src={img.preview}
                                            alt={`Preview ${index}`}
                                            className="w-full h-24 object-cover rounded-lg shadow-md transition-transform transform group-hover:scale-105"
                                        />
                                        <button
                                            type='button'
                                            className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition"
                                            onClick={() => removeImage(index)}
                                        >
                                            <BiXCircle size={20} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className='btn-ctrl'>
                        <button className="buttonviolet w-[200px!important]">
                            {isLoading ? (
                                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <p>Publier les modifications</p>
                            )}
                        </button>
                    </div>

                </form>

            </div>

            {open &&
                <Modal isOpen={open} onClose={handleClose}>
                    <center>
                        <div className='flex flex-col gap-4 items-center justify-center'>
                            <BsCheck2Circle className='text-green-700 text-[50px]' />

                            <p>Votre projet a bien été publié !</p>

                            <button
                                className='buttonviolet'
                                type='submit'
                                onClick={handleClose}
                            >OK</button>

                        </div>
                    </center>
                </Modal>
            }

        </div>
    );
}

export default EditProject;
